/* Adapters for retained merchant/app content. New components do not depend on these. */
(() => {
  const initialize = () => {
    const $ = window.jQuery;
    if (!$) return;
    if ($.fn.accordion) $('.accordion').accordion({ defaultOpen: 'section1', cookieName: 'accordion_nav' });
    if ($.fn.slick) $('.slider-logos:not(.slick-initialized)').slick({
      dots: false, arrows: false, infinite: true, speed: 300,
      slidesToShow: 5, slidesToScroll: 1,
      autoplay: !window.matchMedia('(prefers-reduced-motion: reduce)').matches,
      autoplaySpeed: 3000,
      responsive: [{ breakpoint: 700, settings: { slidesToShow: 3 } }]
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
